import { ElMessage, ElMessageBox } from "element-plus";
import Api_Admin from "../../../../api/System/Admin";
import router from '../../../../router';
import Auth from "../../../../utils/auth";
import Loading from "../../../../utils/Loading"; //获取加载组件

export default {
	name: 'ModuleBox',
	components: {

	},
	props:{
		Visible:{
			type:Boolean,
			default:false
		},
	  },
	data(){
        var CheckPassword = (rule, value, callback) => {
            if (value !== this.Form.NewPassword) {
                callback(new Error("两次输入密码不一致"));
            }else{
				callback();
			}
        };
		return{
			ValueData:'111',

			Form:{
				OldPassword:'',
				NewPassword:'',
				AgainNewPassword:'',
			},

			Rules: {
                OldPassword: [
                    {
                        required: true,
                        message: "请输入旧密码",
                        trigger: "blur",
                    },
                ],
                NewPassword: [
                    {
                        required: true,
                        message: "请输入新密码",
                        trigger: "blur",
                    },
					{
						min:6,
						max:16,
						message:'长度在 6 到 16 个字符',
						trigger:'blur',
					},
                ],
                AgainNewPassword: [
                    {
                        required: true,
                        message: "请输入确认密码",
                        trigger: "blur",
                    },
					{
						validator: CheckPassword,
						trigger: 'blur'
					},
                ]
            },

		}
	},
	methods:{
		Admin_Update_Password_Hide(){
			this.$emit("update:Visible",false);
		},
		Admin_Update_Password_Init_Form(){
			if(this.$refs.RefForm){
				this.$refs.RefForm.clearValidate(); //初始化表单数据
				this.$refs.RefForm.resetFields(); //初始化检查表单
			}
		},
		Admin_Update_Password_Input_Clear(){
			//console.log('-');
		},
		Admin_Update_Password_Submit(){
			this.$refs.RefForm.validate(async (valid) => {
                if (valid) {
					//判断新旧密码是否一样
					if(this.Form['OldPassword'] == this.Form['NewPassword']){
						ElMessage.error("新旧密码相同，不需要修改");
						return false;
					}

					Loading.LoadingShow();
					let RequestData = {
						OldPassword:this.Form['OldPassword'],
						NewPassword:this.Form['NewPassword'],
					};
					let ReturnData = Api_Admin.UpdateKeyCode(RequestData);
					ReturnData.then(response => {
						Loading.LoadingHide();

						let State = response['Data'][0].State;
						let Message = response['Data'][0].Message;
						//let Menu = response['Data'][0].Data.Menu;
						if(State == 'Success'){
							//赋值Token
							Auth.setToken(response['Data'][0].Token);
							ElMessage.success(Message);
							//关闭对话框
							this.Admin_Update_Password_Hide();
						}else{
							ElMessage.error(Message);
						}
					})


                }else{
                    ElMessage.error("请根据提示完成填写");
                }
			});
		}
	},
	mounted(){
		
	},
    watch: {
		Visible(Value){
			if(Value){
				//初始化表单
				this.Admin_Update_Password_Init_Form();
			}
		}
    },
    emits:{
		"update:Visible":null,
    }
}